import { Component, OnInit, ViewChild, Input, Output } from "@angular/core";
import { WeGoConfig } from "../config";
import { EventEmitter } from "events";
import { TranslateService } from "../translate";
import { ModalDirective } from "ng2-bootstrap/components/modal";
import { CarouselComponent } from "ng2-bootstrap/components/carousel";

@Component({
  selector: "wego-image-slider",
  template: require('../views/wego-image-slider.popup.component.html'),
  styles: [
    `.custom-modal-width {
                width:530px;
          }
      .image-max-width{
        max-width: 500px;
      }`
  ]
})
export class ImageSliderComponent implements OnInit {
  constructor(private translate: TranslateService) {}

  _popupTitle: string = this.translate.instant("LblSuccess");
  _additionalInfo: string = "";

  @Input()
  set popupTitle(popupTitle: string) {
    this._popupTitle =
      (popupTitle && popupTitle.trim()) || this.translate.instant("LblSuccess");
  }
  get popupTitle() {
    return this._popupTitle;
  }

  @Input()
  set additionalInformation(additionalInfo: string) {
    this._additionalInfo = (additionalInfo && additionalInfo.trim()) || "";
  }
  get additionalInformation() {
    return this._additionalInfo;
  }

  @Output() onConfirm = new EventEmitter();

  public Imagelist: string[] = [];

  @ViewChild("imageSliderModal") public imageSliderModal: ModalDirective;

  ngOnInit() {
    this.Imagelist = [];
  }

  public GetImageURL(imagePath: string) {
    return imagePath;
  }

  public show(
    popupTitle: string = "",
    additionalInfo: string = "",
    imageList: string[]
  ) {
    this._popupTitle = popupTitle;
    this.Imagelist = imageList;
    this._additionalInfo = additionalInfo;
    this.imageSliderModal.show();
  }

  public hide() {
    this.imageSliderModal.hide();
  }

  private Confirm($event: any) {
    this.hide();
    this.onConfirm.emit($event);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/popup/image-slider-popup.component.ts